export const nid = (prefix = 'id') =>
  `${prefix}_${Math.random().toString(36).slice(2, 9)}${Date.now().toString(36).slice(-3)}`;

export const nowISO = () => new Date().toISOString();

export const fmtDate = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
};

export const fmtDateTime = (iso) => {
  if (!iso) return '—';
  const d = new Date(iso);
  return d.toLocaleString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const relTime = (iso) => {
  if (!iso) return '—';
  const diff = Date.now() - new Date(iso).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m}m ago`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.floor(h / 24);
  if (d < 30) return `${d}d ago`;
  return fmtDate(iso);
};

export const calculateRisk = (p, i, c) => {
  const score = (p || 0) * (i || 0) * (c || 0);
  let band, label, variant;
  if (score <= 20) {
    band = 'low';
    label = 'Low';
    variant = 'ok';
  } else if (score <= 50) {
    band = 'medium';
    label = 'Medium';
    variant = 'info';
  } else if (score <= 80) {
    band = 'high';
    label = 'High';
    variant = 'warn';
  } else {
    band = 'critical';
    label = 'Critical';
    variant = 'danger';
  }
  return { score, band, label, variant };
};

export const formatBytes = (bytes) => {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
};